import React, { memo, useMemo } from 'react';
import { Breadcrumbs } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';

export interface CBreadcrumbItem {
  title: string;
  link?: string;
  onClick?(): void;
}

export interface CBreadcrumbProps {
  items: CBreadcrumbItem[];
  listClassName?: string;
  noLink?: boolean;
}

const useStyles = makeStyles({
  root: {
    fontSize: 'inherit !important',
    fontFamily: 'inherit !important',
    lineHeight: 'inheret !important',
    letterSpacing: 'inherent !important',
    'font-weight': 'inherit !important',
  },
});

export const CBreadcrumb = memo((props: CBreadcrumbProps) => {
  const { items, listClassName, noLink = false } = props;
  const classes = useStyles();
  const itemsLength = useMemo(() => items.length, [items]);

  if (!itemsLength) return null;

  return (
    <Breadcrumbs
      separator={<i className="bx bx-right-arrow-alt"></i>}
      aria-label="breadcrumb"
      className="breadcrumb-inheret"
      classes={{
        root: classes.root,
        ol: 'breadcrumb m-0',
        li: 'breadcrumb-item',
      }}
    >
      {noLink && items.map((item, index) => <span key={index}>{item.title}</span>)}
      {!noLink &&
        items.map((item, index) => (
          <>
            {itemsLength === index + 1 && item.title}
            {itemsLength != index + 1 && (
              <Link key={index} color="inherit" to={item.link || ''} onClick={item.onClick}>
                {item.title}
              </Link>
            )}
          </>
        ))}
    </Breadcrumbs>
  );
});

// import React, { memo } from 'react';
// import { Breadcrumb, BreadcrumbItem } from 'reactstrap';

// export interface CBreadcrumbItem {
//   title: string;
//   link?: string;
//   onClick?(): void;
// }

// export interface CBreadcrumbProps {
//   items: CBreadcrumbItem[];
//   listClassName?: string;
//   noLink?: boolean;
// }

// export const CBreadcrumb = memo((props: CBreadcrumbProps) => {
//   const { items, listClassName, noLink = false } = props;
//   if (!items.length) return null;
//   return (
//     <Breadcrumb tag="nav" listTag="div" listClassName={`pl-0 bg-transparent no-padding ${listClassName}`}>
//       {items.map((item, index) => (
//         <BreadcrumbItem key={index} active={items.length === index + 1 || noLink} tag="a" href={item.link} onClick={item.onClick}>
//           {item.title}
//         </BreadcrumbItem>
//       ))}
//     </Breadcrumb>
//   );
// });
